/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConfirmUserParams,
  RequestChangePasswordRequest,
  RequestLoginRequest,
  RequestRefreshTokenRequest,
  RequestRegisterUserRequest,
  RequestResetPasswordRequest,
  RequestSendPasswordResetEmailRequest,
  RequestTwoFactorAuthenticationTwoFactorChangeStateRequest,
  RequestTwoFactorAuthenticationTwoFactorCodeVerificationRequest,
  RequestUpdateLanguageCodeRequest,
  RequestUpdatePhoneNumberRequest,
  RequestUpdateUserRequest,
  RequestUserConfirmationSignature,
  RequestUsersCheckPasswordStrengthRequest,
  RequestUsersOtpLoginRequest,
  ResponseCreateUnconfirmedUserResponse,
  ResponseTwoFactorCodeResponse,
  ResponseTwoFactorNotEnforcedUserResponse,
  ResponseUserPreferenceResponse,
  ResponseUserResponse,
  SendEmailVerificationParams,
  SetUserCurrentMoodsPayload,
  SetUserPreferencesBody,
  UpdateUserLanguageParams,
  UpdateUserPhoneNumberWithTokenParams,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Users<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
 * No description
 *
 * @tags TwoFactorAuthentication
 * @name ChangeTwoFactorAuthenticationState
 * @summary Verifies whether token is correct
Activates 2FA for the user (Auth policies: GuestOrClientOrExpertPolicy, UserHavingAnyRoleTwoFactorNotRequiredPolicy)
 * @request PATCH:/api/v1/users/2fa/state
 * @secure
 * @response `200` `void` OK
 * @response `401` `void` Unauthorized
 * @response `403` `void` Forbidden
 */
  changeTwoFactorAuthenticationState = (
    data: RequestTwoFactorAuthenticationTwoFactorChangeStateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/users/2fa/state`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name ChangeUserPassword
   * @summary API to allow a user to change their password (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request POST:/api/v1/users/change-user-password
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  changeUserPassword = (
    data: RequestChangePasswordRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/users/change-user-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name CheckPasswordStrength
   * @summary Checks if a password is compromised/weak based on known data breaches
   * @request POST:/api/v1/users/passwords/strength
   * @secure
   * @response `200` `void` OK
   */
  checkPasswordStrength = (
    data: RequestUsersCheckPasswordStrengthRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/api/v1/users/passwords/strength`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name ConfirmUser
   * @summary Handles the user email verification link (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request PUT:/api/v1/users/confirm-user
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  confirmUser = (
    query: ConfirmUserParams,
    data: RequestUserConfirmationSignature,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/users/confirm-user`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TwoFactorAuthentication
   * @name EnableTwoFactorLogin
   * @summary Once the user has scanned the google QR code, enable 2FA. (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request PATCH:/api/v1/users/2fa/authenticator/enable
   * @secure
   * @response `200` `ResponseUserResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  enableTwoFactorLogin = (params: RequestParams = {}) =>
    this.http.request<ResponseUserResponse, void>({
      path: `/api/v1/users/2fa/authenticator/enable`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetGuestUserProfile
   * @summary Once authorized to get the user's details (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/users/guest-profile
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedUserResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getGuestUserProfile = (params: RequestParams = {}) =>
    this.http.request<ResponseTwoFactorNotEnforcedUserResponse, void>({
      path: `/api/v1/users/guest-profile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetMinimalUserProfile
   * @summary Once authorized to get the user's details (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/users/minimal-profile
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedUserResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getMinimalUserProfile = (params: RequestParams = {}) =>
    this.http.request<ResponseTwoFactorNotEnforcedUserResponse, void>({
      path: `/api/v1/users/minimal-profile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetUserCurrentMoods
   * @summary  (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request GET:/api/v1/users/currentMoods
   * @secure
   * @response `200` `(ResponseUserPreferenceResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserCurrentMoods = (params: RequestParams = {}) =>
    this.http.request<ResponseUserPreferenceResponse[], void>({
      path: `/api/v1/users/currentMoods`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetUserPreferences
   * @summary Returns the current user's preferences (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request GET:/api/v1/users/preferences
   * @secure
   * @response `200` `(ResponseUserPreferenceResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserPreferences = (params: RequestParams = {}) =>
    this.http.request<ResponseUserPreferenceResponse[], void>({
      path: `/api/v1/users/preferences`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetUserProfile
   * @summary Once authorized to get the user's details (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request GET:/api/v1/users/profile
   * @deprecated
   * @secure
   * @response `200` `ResponseUserResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserProfile = (params: RequestParams = {}) =>
    this.http.request<ResponseUserResponse, void>({
      path: `/api/v1/users/profile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name Login
   * @summary Login method - provide user name and password to this method and returns JWT access token
   * @request POST:/api/v1/users/login
   * @deprecated
   * @secure
   * @response `200` `void` OK
   */
  login = (data: RequestLoginRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v1/users/login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name Logout
   * @summary  (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request POST:/api/v1/users/logout
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  logout = (params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/users/logout`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name LogoutAll
   * @summary  (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request POST:/api/v1/users/logout-all
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  logoutAll = (params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/users/logout-all`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name OtpLogin
   * @summary Login method - provide user name and password to this method and returns JWT access token
   * @request POST:/api/v1/users/otp-login
   * @secure
   * @response `200` `void` OK
   */
  otpLogin = (data: RequestUsersOtpLoginRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v1/users/otp-login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name RefreshToken
   * @summary Attempt to refresh the current access token
   * @request POST:/api/v1/users/refresh-token
   * @secure
   * @response `200` `void` OK
   */
  refreshToken = (
    data: RequestRefreshTokenRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/api/v1/users/refresh-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TwoFactorAuthentication
   * @name RegisterTwoFactorLogin
   * @summary Gets a 2FA registration code if the user has not already enabled it. (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/users/2fa/authenticator/registration-info
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  registerTwoFactorLogin = (params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/users/2fa/authenticator/registration-info`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name RegisterUser
   * @summary Register new user
   * @request POST:/api/v1/users/register-user
   * @secure
   * @response `200` `ResponseCreateUnconfirmedUserResponse` OK
   */
  registerUser = (
    data: RequestRegisterUserRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseCreateUnconfirmedUserResponse, any>({
      path: `/api/v1/users/register-user`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name ResetPassword
   * @summary Api to reset password of user after the user has requested a password reset code
   * @request PUT:/api/v1/users/reset-password
   * @secure
   * @response `200` `void` OK
   */
  resetPassword = (
    data: RequestResetPasswordRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/api/v1/users/reset-password`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name SendEmailVerification
   * @summary Send an email to verify the user's email address
   * @request POST:/api/v1/users/send-email-verification
   * @secure
   * @response `200` `void` OK
   */
  sendEmailVerification = (
    query: SendEmailVerificationParams,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/api/v1/users/send-email-verification`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name SendPasswordResetEmail
   * @summary API to send a forgot password email
   * @request POST:/api/v1/users/send-password-reset-email
   * @secure
   * @response `200` `void` OK
   */
  sendPasswordResetEmail = (
    data: RequestSendPasswordResetEmailRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/api/v1/users/send-password-reset-email`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
 * No description
 *
 * @tags TwoFactorAuthentication
 * @name SendSmsCode
 * @summary Generates a 6 digit authentication token for the user
Asynchronosly sends an SMS with the token to the user's phone number (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
 * @request POST:/api/v1/users/2fa/send-code
 * @secure
 * @response `200` `ResponseTwoFactorCodeResponse` OK
 * @response `401` `void` Unauthorized
 * @response `403` `void` Forbidden
 */
  sendSmsCode = (params: RequestParams = {}) =>
    this.http.request<ResponseTwoFactorCodeResponse, void>({
      path: `/api/v1/users/2fa/send-code`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name SetUserCurrentMoods
   * @summary Sets the current user's preferences (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request POST:/api/v1/users/currentMoods
   * @secure
   * @response `200` `(ResponseUserPreferenceResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  setUserCurrentMoods = (
    data: SetUserCurrentMoodsPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseUserPreferenceResponse[], void>({
      path: `/api/v1/users/currentMoods`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name SetUserPreferences
   * @summary Sets the current user's preferences (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request POST:/api/v1/users/preferences
   * @secure
   * @response `200` `(ResponseUserPreferenceResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  setUserPreferences = (
    data: SetUserPreferencesBody,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseUserPreferenceResponse[], void>({
      path: `/api/v1/users/preferences`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateUser
   * @summary Update the current user's details (Auth policies: ClientOrExpertPolicy, GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request PUT:/api/v1/users/update-user
   * @deprecated
   * @secure
   * @response `200` `ResponseUserResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateUser = (data: RequestUpdateUserRequest, params: RequestParams = {}) =>
    this.http.request<ResponseUserResponse, void>({
      path: `/api/v1/users/update-user`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateUserLanguage
   * @summary Updates the user's language according to the supplied language header (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request PUT:/api/v1/users/update-language
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateUserLanguage = (
    query: UpdateUserLanguageParams,
    data: RequestUpdateLanguageCodeRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/users/update-language`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateUserPhoneNumber
   * @summary Updates the user's phone number (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request PUT:/api/v1/users/phone-number
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateUserPhoneNumber = (
    data: RequestUpdatePhoneNumberRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/users/phone-number`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateUserPhoneNumberWithToken
   * @summary Updates the user's phone number (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request PUT:/api/v1/users/phone-number-with-token
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateUserPhoneNumberWithToken = (
    query: UpdateUserPhoneNumberWithTokenParams,
    data: RequestUpdatePhoneNumberRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/users/phone-number-with-token`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
 * No description
 *
 * @tags TwoFactorAuthentication
 * @name ValidateToken
 * @summary Verifies whether token is correct
Logs user in and returns access/refresh tokens (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
 * @request POST:/api/v1/users/2fa/validate
 * @secure
 * @response `200` `void` OK
 * @response `401` `void` Unauthorized
 * @response `403` `void` Forbidden
 */
  validateToken = (
    data: RequestTwoFactorAuthenticationTwoFactorCodeVerificationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/users/2fa/validate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
